import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import { imagesAssets } from "../assets/images";
// import { business, user } from "./nav";
import { user } from "./nav";
import { useDispatch } from "react-redux";
import { REQUEST_LOGOUT_USER } from "../store/auth/actionTypes";

const drawerWidth = 280;

interface Props {
  window?: () => Window;
}

// interface NavItem {
//   path: string;
//   activeIcon: string;
//   icon: string;
//   name: string;
// }

const DefaultLayout = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // const [navbar, setNavbar] = React.useState<NavItem[]>([]);

  // useEffect(() => {
  //   if (location.pathname.includes("/b/")) {
  //     setNavbar(business);
  //   } else if (location.pathname.includes("/u/")) {
  //     setNavbar(user);
  //   }
  // }, []);

  const { window } = props;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const logout = () => {
    dispatch({
      type: REQUEST_LOGOUT_USER,
    });
  };

  const drawer = (
    <div
      className="sidebar_drawer_wrp sidebar-drawer"
      style={{ position: "relative" }}
    >
      <Toolbar className="app-logo">
        <img src={imagesAssets.logo} alt="logo" />
        <span className="title">Executavia</span>
      </Toolbar>
      <Divider />
      <List className="sidebar_drawer_wrp_list">
        {user.map((nav, index) => (
          <ListItem
            key={index}
            disablePadding
            className={`list ${
              location.pathname === nav.path ||
              ((location.pathname.includes("businessdetails") ||
                location.pathname.includes("addbusiness")) &&
                nav.path === "/mybusiness") ||
              (location.pathname.includes("subscriptionsBusiness") &&
                nav.path === "/managesubscriptions")
                ? "active"
                : ""
            }`}
          >
            {/* <ListItemButton onClick={() => navigate(nav.path)}> */}
            <ListItemButton
              onClick={() => {
                navigate(nav.path);
                setTimeout(() => {
                  handleDrawerClose();
                }, 100);
              }}
            >
              <ListItemIcon>
                <img
                  src={
                    location.pathname === nav.path ||
                    ((location.pathname.includes("businessdetails") ||
                      location.pathname.includes("addbusiness")) &&
                      nav.path === "/mybusiness") ||
                    (location.pathname.includes("subscriptionsBusiness") &&
                      nav.path === "/managesubscriptions")
                      ? nav?.activeIcon
                      : nav?.icon
                  }
                  className="list-img"
                  alt="logo"
                />
              </ListItemIcon>
              <ListItemText
                primary={nav?.name}
                className={`list-name ${
                  location.pathname === nav.path ||
                  ((location.pathname.includes("businessdetails") ||
                    location.pathname.includes("addbusiness")) &&
                    nav.path === "/mybusiness") ||
                  (location.pathname.includes("subscriptionsBusiness") &&
                    nav.path === "/managesubscriptions")
                    ? "active"
                    : ""
                }`}
              />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding className={`list logout`}>
          {/* <ListItemButton onClick={() => navigate("/login")}> */}
          <ListItemButton onClick={logout}>
            <ListItemIcon>
              <img src={imagesAssets.logout} className="list-img" alt="logo" />
            </ListItemIcon>
            <ListItemText primary={"Log out"} className={`list-name`} />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className="sidebar-container">
      <Box sx={{ display: "flex" }}>
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
            className="sidebar_drawer"
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            pt: 9,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            height: "fit-content",
            // minHeight: `calc(100vh - 96px)`,
            backgroundColor: "#F2ECE6",
            paddingTop: "92px",
            overflowX: "hidden",
          }}
          style={{ width: "330px" }}
        >
          <Toolbar />
          <Outlet context={{ handleDrawerToggle: handleDrawerToggle }} />
        </Box>
      </Box>
    </div>
  );
};

export default DefaultLayout;
